// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__1v37Y","loaderOuter":"PageOverlayLoader_loaderOuter__wGyfH"};